import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { type Cnam } from 'entities/Compliance/model/OrganizationCnam/Cnam'
import { type SummaryStore } from 'pages/settings/pages/compliance/pages/calling/store/SummaryStore'

type ICnamCallerIdSummaryModalActionsProps = {
  store: SummaryStore
  cnam: Cnam
}

export const CnamCallerIdSummaryModalActions = observer(
  ({ store, cnam }: ICnamCallerIdSummaryModalActionsProps) => {
    const { canDelete, canEdit } = cnam

    return (
      <>
        {canDelete && (
          <Button
            icon='delete'
            contained={'secondary'}
            intent='destructive'
            text='Delete Caller ID'
            iconProps={{
              color: 'var(--content-destructive-secondary)',
            }}
            onClick={() => store.onDeleteCnamCallerIdModal(cnam)}
          />
        )}
        {canEdit && (
          <Button
            icon='edit'
            contained={'secondary'}
            text='Edit numbers'
            onClick={() => store.onEditCnamNumbers(cnam)}
          />
        )}
      </>
    )
  }
)
